module.exports = __webpack_public_path__ + "static/media/service-international-orders-1.a720518a.png";